import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import endpoints from "../../endpoint";
import axios from "axios";

// async thunk for  fetching the course videos by coursID

export const fetchCourseVideoByCourseId = createAsyncThunk(
  "/purchase/fetchPurchaseVideoByCourseId",
  async (courseId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        endpoints.serverBaseUrl + `api/student/course/${courseId}/videos`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response?.data?.videos;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

// async thunk for fetching the purchased course
export const fetchPurchasedCourse = createAsyncThunk(
  "/purchase/fetchPurchasedCourse",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        endpoints.serverBaseUrl + "api/student/purchasedcourses",
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      return response?.data?.purchasedCourses;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

const videoSlice = createSlice({
  name: "purchase",
  initialState: {
    loading: false,
    error: null,
    videos: [],
    course: [],
    purchasedCoursesLoaded: false,
  },
  reducers: {
    addvideos: (state, action) => {
      state.videos = action.payload;
    },
    addPurchaseCourse: (state, action) => {
      state.course = action.payload;
      state.purchasedCoursesLoaded = true;
    },
  },

  extraReducers: (builder) => {
    // handle fetchVideoByCourseId
    builder
      .addCase(fetchCourseVideoByCourseId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCourseVideoByCourseId.fulfilled, (state, action) => {
        state.loading = false;
        state.videos = action.payload;
      })
      .addCase(fetchCourseVideoByCourseId.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // Handle fetchPurchased Course
      .addCase(fetchPurchasedCourse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPurchasedCourse.fulfilled, (state, action) => {
        state.loading = false;
        state.course = action.payload;
        state.purchasedCoursesLoaded = true;
      })
      .addCase(fetchPurchasedCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addvideos, addPurchaseCourse } = videoSlice.actions;
export default videoSlice.reducer;
